import React from 'react';

const FormPreview = ({ formData, onGoToList }) => {
    return (
        <div className="text-center py-5">
            <div className="mb-4">
                <svg
                    className="text-success"
                    width="80"
                    height="80"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            </div>

            <h4 className="mb-3">설문이 생성되었습니다!</h4>


            <button className="btn btn-primary" onClick={onGoToList}>
                폼 목록으로 이동
            </button>
        </div>
    );
};

export default FormPreview;
